class ChatSocket {
  constructor() {
    this.socket = null
    this.url = ''
    this.isConnected = false
    this.messageHandlers = []
  }

  connect(url) {
    this.url = url
    try {
      this.socket = new WebSocket(url)

      this.socket.onopen = () => {
        this.isConnected = true
        console.log('Chat socket connected')
      }

      this.socket.onmessage = (event) => {
        const data = JSON.parse(event.data)
        this.messageHandlers.forEach(handler => handler(data))
      }

      this.socket.onclose = () => {
        this.isConnected = false
        console.log('Chat socket disconnected')
      }

      this.socket.onerror = (error) => {
        console.error('Chat socket error:', error)
      }
    } catch (error) {
      console.error('Failed to connect to chat socket:', error)
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.close()
      this.socket = null
      this.isConnected = false
    }
  }

  send(message) {
    if (this.socket && this.isConnected) {
      this.socket.send(JSON.stringify(message))
    }
  }

  onMessage(handler) {
    this.messageHandlers.push(handler)
  }

  removeMessageHandler(handler) {
    const index = this.messageHandlers.indexOf(handler)
    if (index > -1) {
      this.messageHandlers.splice(index, 1)
    }
  }
}

export default new ChatSocket()